<template>
    <div>
        <keep-alive>
            <base-header></base-header>
        </keep-alive>

        <router-view></router-view>

        <keep-alive>
            <base-footer v-show="$route.name !== 'app'"></base-footer>
        </keep-alive>
    </div>
</template>

<script>
    import BaseHeader from './components/base/Header.vue'
    import BaseFooter from './components/base/Footer.vue'
    // import wx from 'weixin-js-sdk'

    export default {
        components: {
            BaseHeader,
            BaseFooter,
        },
        /*computed: {
            change() {
                return this.$store.state.change;
            },
            title() {
                return this.$store.state.title;
            },
            imgUrl() {
                return this.$store.state.cover;
            }
        },
        watch: {
            change() {
                const link = window.location.href, {title, imgUrl} = this;
                this.api.post('sign/wx', {link}).then(e => {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: e.appId, // 必填，公众号的唯一标识
                        timestamp: e.timestamp, // 必填，生成签名的时间戳
                        nonceStr: e.nonceStr, // 必填，生成签名的随机串
                        signature: e.signature,// 必填，签名
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                        ] // 必填，需要使用的JS接口列表
                    });
                    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                        wx.updateAppMessageShareData({
                            title, // 分享标题
                            desc: '更多精彩，尽在 Vhiphop 唯舞。', // 分享描述
                            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl, // 分享图标
                            success: function () {
                                // 设置成功
                            }
                        });
                        wx.updateTimelineShareData({
                            title, // 分享标题
                            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl, // 分享图标
                            success: function () {
                                // 设置成功
                            }
                        });
                    });
                });
            }
        }*/
    }
</script>

<style>
    @import "../static/css/base/icon.css";
    @import "../static/css/base/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue